var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('a-table',{attrs:{"bordered":"","data-source":_vm.item.list,"pagination":false,"rowKey":"id","row-selection":{
    selectedRowKeys: _vm.selectedRowKeys,
    onChange: _vm.onSelectChange,
  }}},[_c('a-table-column',{attrs:{"title":"附件名称","data-index":"name","align":"center"}}),_c('a-table-column',{attrs:{"title":"操作","align":"center","width":"50px"},scopedSlots:_vm._u([{key:"default",fn:function(text){return [_c('a',{on:{"click":function($event){return _vm.download(text)}}},[_vm._v("下载")])]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }